import classNames from 'classnames';
import * as _ from 'lodash-es';
import React from 'react';
import * as styles from './TutorialProgress.module.scss';

interface TutorialProgressProps {
  at: number;
  total: number;
}

const TutorialProgress = ({ at, total }: TutorialProgressProps) => (
  <div className={styles.dots}>
    {_.range(total).map((index) => (
      <div
        key={index}
        className={classNames(styles.dot, {
          [styles.active]: index === at,
        })}
      />
    ))}
  </div>
);

export default TutorialProgress;
